import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { validators } from 'investira.sdk';
import { Stack, LoadingButton, Icon, Divider, Typography } from 'investira.react.components';
import { PageTemplate } from '../../../components/templates';
import { useAvaliacoesContext } from '../../../contexts/AvaliacoesContext';
import AvaliacoesOutputHighlights from './AvaliacoesOutputHighlights';
import AvaliacoesOutputResumo from './AvaliacoesOutputResumo';
import AvaliacoesOutputPerfomance from './AvaliacoesOutputPerfomance';
import AvaliacaoOutputHeader from './AvaliacaoOutputHeader';
import AvaliacoesOutputRespostas from './AvaliacoesOutputRespostas/AvaliacoesOutputRespostas';

const AvaliacoesOutput = memo(props => {
  const { state } = useAvaliacoesContext();
  const { gestor } = state;

  const NOTA_QUALITATIVA = Math.round(Math.random() * 3); // 70%
  const NOTA_QUANTITATIVA = Math.round(Math.random() * 3); // 30%

  const NOTA = NOTA_QUALITATIVA * 0.7 + NOTA_QUANTITATIVA * 0.3;

  return (
    <PageTemplate
      title={gestor.pessoa_fantasia || 'Alpha Asset Management Ltda.'}
      subtitle={'Avaliação Gestor'}
      maxWidth={'xl'}
      headerRenderActions={
        <Stack direction="row" spacing={2} alignItems="center">
          <LoadingButton
            //disabled={!props.isFinished || !validators.isEmpty(props.filesErrors)}
            //loading={!props.isFinished}
            variant="contained"
            color="primary"
            startIcon={<Icon iconName="download" size={16} />}
            size="small"
            sx={{ px: 2 }}>
            PDF
          </LoadingButton>
        </Stack>
      }>
      <Stack gap={3}>
        <Stack gap={1}>
          <AvaliacaoOutputHeader />
          <Divider />
        </Stack>
        <Stack gap={2} flexGrow={1} direction="row">
          <AvaliacoesOutputHighlights
            nota={NOTA}
            notaQualitativa={NOTA_QUALITATIVA}
            notaQuantitativa={NOTA_QUANTITATIVA}
          />
          <AvaliacoesOutputPerfomance />
        </Stack>
        <Divider />
        {/* TODO: Exibir dados da gestora com logo */}
        <AvaliacoesOutputResumo gestor={gestor} nota={NOTA} />
        <Divider />
        <AvaliacoesOutputRespostas />
      </Stack>
    </PageTemplate>
  );
});

AvaliacoesOutput.displayName = 'AvaliacoesOutput';

export default AvaliacoesOutput;
